export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.RightContent.profile': 'Profile',
  'component.RightContent.logout': 'Logout',
  'component.message.success.save': 'Save successfully',
  'component.message.error.save': 'Failed to save',
  'component.message.success.delete': 'Delete successfully',
  'pages.table.column.operation': '操作',
};
